"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var mobx_react_1 = require("mobx-react");
var Footer_1 = require("./Footer");
var parts_1 = require("./parts");
var Section1 = (function (_super) {
    __extends(Section1, _super);
    function Section1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Section1.prototype.render = function () {
        var _a = this.props, json_data = _a.json_data, onChange = _a.onChange;
        var _b = this.props, model = _b.model, errors = _b.errors;
        return (React.createElement("div", { style: { fontSize: "13px" } },
            React.createElement(parts_1.Identification, { model: model, errors: errors }),
            React.createElement(parts_1.Program, { model: model, onChange: onChange, json_data: json_data, errors: errors }),
            React.createElement(parts_1.FinancialHeader, null),
            React.createElement(parts_1.FinancialItem, { model: model, onChange: onChange, json_data: json_data }),
            React.createElement(parts_1.FinancialFooter, { onChange: onChange, model: model, errors: errors }),
            React.createElement(Footer_1.Footer, { page: 1 })));
    };
    Section1 = __decorate([
        mobx_react_1.observer
    ], Section1);
    return Section1;
}(react_1.Component));
exports.Section1 = Section1;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2VjdGlvbjEuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9pbnRlbGxpdGVjL0Vucm9sbG1lbnRBZ3JlZW1lbnQvTnVyc2luZy9TZWN0aW9uMS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDJDQUE4QjtBQUM5QiwrQkFBK0I7QUFDL0IseUNBQW1DO0FBR25DLG1DQUErQjtBQUMvQixpQ0FBZ0c7QUFXaEc7SUFBOEIsNEJBQW9CO0lBQWxEOztJQWdCQSxDQUFDO0lBZlUseUJBQU0sR0FBYjtRQUNVLElBQUEsZUFBa0MsRUFBakMsd0JBQVMsRUFBRSxzQkFBc0IsQ0FBQTtRQUNsQyxJQUFBLGVBQTRCLEVBQTNCLGdCQUFLLEVBQUUsa0JBQW9CLENBQUE7UUFFbEMsT0FBTyxDQUNILDZCQUFLLEtBQUssRUFBRSxFQUFDLFFBQVEsRUFBRSxNQUFNLEVBQUM7WUFDMUIsb0JBQUMsc0JBQWMsSUFBQyxLQUFLLEVBQUUsS0FBSyxFQUFFLE1BQU0sRUFBRSxNQUFNLEdBQUk7WUFDaEQsb0JBQUMsZUFBTyxJQUFDLEtBQUssRUFBRSxLQUFLLEVBQUUsUUFBUSxFQUFFLFFBQVEsRUFBRSxTQUFTLEVBQUUsU0FBUyxFQUFFLE1BQU0sRUFBRSxNQUFNLEdBQUk7WUFDbkYsb0JBQUMsdUJBQWUsT0FBRztZQUNuQixvQkFBQyxxQkFBYSxJQUFDLEtBQUssRUFBRSxLQUFLLEVBQUUsUUFBUSxFQUFFLFFBQVEsRUFBRSxTQUFTLEVBQUUsU0FBUyxHQUFJO1lBQ3pFLG9CQUFDLHVCQUFlLElBQUMsUUFBUSxFQUFFLFFBQVEsRUFBRSxLQUFLLEVBQUUsS0FBSyxFQUFFLE1BQU0sRUFBRSxNQUFNLEdBQUk7WUFDckUsb0JBQUMsZUFBTSxJQUFDLElBQUksRUFBRSxDQUFDLEdBQUksQ0FDakIsQ0FDVCxDQUFBO0lBQ0wsQ0FBQztJQWZRLFFBQVE7UUFEcEIscUJBQVE7T0FDSSxRQUFRLENBZ0JwQjtJQUFELGVBQUM7Q0FBQSxBQWhCRCxDQUE4QixpQkFBUyxHQWdCdEM7QUFoQlksNEJBQVEifQ==